module.exports = __webpack_public_path__ + "img/solution-vil-system-pic-2.231861e9.png";